
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import styles from '../core-exchange.module.scss';
export const metadata = {
  toc: true,
  subnav: true,
  title: "Dashboard overview",
  layout: "guide",
  description: "Configure your institution, manage environments, and monitor integration health",
  parentTocLevel: 2,
  childTocLevel: 3,
  secondLevelToc: true,
  alwaysExpand: true
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Image = makeShortcode("Image");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className={styles.page}>
      <Header title={metadata.title} subtitle={metadata.description} mdxType="Header" />
      <h2 {...{
        "id": "your-institution-profile"
      }}>{`Your institution profile`}</h2>
      <p>{`After signup, you'll land on the Overview page. Before you can start using Core Exchange, complete your profile by providing basic information about your institution. This includes:`}</p>
      <ul>
        <li parentName="ul">{`Verifying your email address`}</li>
        <li parentName="ul">{`Basic information about your institution`}</li>
        <li parentName="ul">{`Business information about your company`}</li>
        <li parentName="ul">{`Technical contact information`}</li>
      </ul>
      <p>{`For a full list of required information, see `}<a parentName="p" {...{
          "href": "/core-exchange/docs/implementation-checklist#scoping-and-implementation"
        }}>{`Implementation checklist`}</a>{`.`}</p>
      <Image src="/assets/img/core-exchange/complete-profile.png" alt="Dashboard profile completion screen showing required information steps" caption="Complete your profile to get started" expandable={true} mdxType="Image" />
      <h2 {...{
        "id": "institutions"
      }}>{`Institutions`}</h2>
      <p>{`The `}<strong parentName="p">{`Institutions`}</strong>{` section enables you to configure Plaid's access to your API and establish your institution's brand in Plaid Link. Configuration differs based on your integration model. For details on single institution vs platform models, see the `}<a parentName="p" {...{
          "href": "/core-exchange/docs/onboarding-guide#integration-models-single-institution-vs-platform"
        }}>{`onboarding guide`}</a>{`.`}</p>
      <h3 {...{
        "id": "oauth-and-api-configuration"
      }}>{`OAuth and API configuration`}</h3>
      <p>{`Configure your OAuth endpoints, client credentials, and API base URL for each environment.`}</p>
      <Image src="/assets/img/core-exchange/config.png" alt="Institution OAuth and API configuration screen showing environment profiles" caption="Your institution's OAuth and API configuration" expandable={true} mdxType="Image" />
      <h3 {...{
        "id": "brand-editor"
      }}>{`Brand editor`}</h3>
      <p>{`Configure your logo, institution name, and institution URL. Your logo file must be a 96x96 or 152x152 circular PNG and under 2MB.`}</p>
      <Image src="/assets/img/core-exchange/brand-editor.png" alt="Brand Editor showing fields for logo, institution name, and URL" caption="Configure your institution's brand information" expandable={true} mdxType="Image" />
      <h3 {...{
        "id": "platform-institutions-view"
      }}>{`Platform institutions view`}</h3>
      <p>{`Platform accounts manage multiple institutions from a single dashboard. Each institution entry represents a distinct configuration.`}</p>
      <Image src="/assets/img/core-exchange/platforms-list.png" alt="Platform view showing a list of managed institutions" caption="Platform institutions view" expandable={true} mdxType="Image" />
      <h2 {...{
        "id": "after-launch"
      }}>{`After launch`}</h2>
      <p>{`Once your integration is live, the Dashboard also provides real-time integration health metrics, detailed error logs, and an Issue Center for monitoring and resolving issues. See `}<a parentName="p" {...{
          "href": "/core-exchange/docs/post-launch/dashboard"
        }}>{`Dashboard monitoring`}</a>{` for details.`}</p>
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "your-institution-profile",
        level: 2,
        title: "Your institution profile",
      },
{
        id: "institutions",
        level: 2,
        title: "Institutions",
      },
{
        id: "oauth-and-api-configuration",
        level: 3,
        title: "OAuth and API configuration",
      },
{
        id: "brand-editor",
        level: 3,
        title: "Brand editor",
      },
{
        id: "platform-institutions-view",
        level: 3,
        title: "Platform institutions view",
      },
{
        id: "after-launch",
        level: 2,
        title: "After launch",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
